//#region imports
import React, { useState, useEffect, useRef } from "react";
import { View, StyleSheet, SafeAreaView, Platform, useWindowDimensions, Image, ActivityIndicator } from "react-native";
import CustomButton from "../../CustomButton/";
import CustomLabel from "../../CustomLabel/CustomLabel";
import { useAccountContext } from "../../../hooks/useAccountContext";
import CustomInput from "../../CustomInput/CustomInput";
import CustomDropdown from "../../CustomDropDown/CustomDropdown";
import { Card, Checkbox } from "react-native-paper";
import { showMessage } from "react-native-flash-message";
import CustomSection from "../Section/CustomSection";
import { useAssessment } from "../../../hooks/useAssessment";
import { generateUniqueID } from "../../SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import CustomCalendar from "../../CustomCalendar/CustomCalendar";
import { LocaleConfig } from 'react-native-calendars';
import { CalendarLocale } from '../../../constants/CalendarLocale';
import { useAuthContext } from "../../../hooks/useAuthContext";
import { useTheme } from "@react-navigation/native";
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import PopUpAssm from "../PopUpAssm/PopUpAssm";
import { ScrollView } from "react-native-gesture-handler";
import { changeDateFromYYYYMMDDToDDMMYYYY } from '../../../constants/FormatDate';
//#endregion

const CustomAssessment = ({
  allAssm,
  assm,
  assmUI,
  setAssm,
  setAssmUi,
  setWfl,
  groups,
  company,
  workflows,
  question_types,
  Editable = 1,
  isEdit = 0,
  sectionQuestionList,
  sectionQuestionListStage1,
  sectionQuestionListStage2,
  sectionQuestionListStage3,
  setSectionQuestionList,
  setShowResponseScreen,
  setShowCreateGroup,
  setShowEditGroup,
  setShowMyAssessments,
  setShowAssessmentsAdmin,
  setShowCreateScreen,
  setShowEditScreen,
  setShowParticipationsScreen,
  isCreate = 0,
  toView = 0,
  response_yn,
  currentStage,
  Stages,
  tccObjects = [],
  isPreview = 0,
  resultIndx = 0,
  showDetails = false,
  isLoading,
  isResult = 0,
}) => {
  //#region Function Definitions
  const { user, clientApi, username } = useAuthContext();
  const { width, height } = useWindowDimensions();
  const { account } = useAccountContext();
  const { colors } = useTheme();
  const styles = makeStyles(colors, width, height);
  const { t, i18n } = useTranslation();
  const tempRangeRef = useRef(null);
  const { postAssessment, updateAssessmentResponse, removeQuestionLineFromUI, removeQuestionFromUI, removeSectionFromUI, SaveAssmInfo } = useAssessment()
  const [saveForPart, setSaveForPart] = useState(0);
  const [datePickerModalOpen, setDatePickerModalOpen] = useState(false);
  const [fromCopy, setFromCopy] = useState(false);
  const [tempRange, setTempRange] = useState({ startDate: '', endDate: '' }); // strings of format yyyy-MM-dd
  const [range, setRange] = useState({ startDate: '', endDate: '' }); // strings of format yyyy-MM-dd
  const [rangeText, setRangeText] = useState(""); // strings of format dd/MM/yyyy
  const rangeTextRef = useRef(null);
  const rangeRef = useRef(null);
  // assign calendar's locale based on selected language and device's location
  LocaleConfig.locales['en'] = CalendarLocale['en'];
  LocaleConfig.locales['gr'] = CalendarLocale['gr'];
  LocaleConfig.defaultLocale = i18n.language;
  const [calendarError, setCalendarError] = useState("");
  const [datesError, setDatesError] = useState("");
  const [selectedWorkflow, setSelectedWorkflow] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedSteps, setSelectedSteps] = useState([]);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [showPartConfirmation, setShowPartConfirmation] = useState(false);
  const [stepsDone, setStepsDone] = useState(0);
  const [sectionEmpty, setSectionEmpty] = useState(false);
  const [importPressed, setImportPressed] = useState(0);
  const [finalizeResponse, setFinalizeResponse] = useState(false);
  const [weightMessage, setWeightMessage] = useState(false)
  const [questionWeightTotal, setQuestionWeightTotal] = useState([0]);
  const [sectionQuant, setSectionQuant] = useState(false);
  const [sectionWeightTotal, setSectionWeightTotal] = useState(0);
  const [showExtraData, setShowExtraData] = useState(false);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageWidth, setImageWidth] = useState(0);
  const isWeb = Platform.OS === 'web';
  const {
    VictoryChart,
    VictoryLine,
    VictoryAxis,
    VictoryScatter
  } = isWeb ? require('victory') : require('victory-native');

  // const imageUrl = 'https://picsum.photos/700';

  // ! Test 
  const [swapAxes, setSwapAxes] = useState(false);

  const [sectionPoint, setSectionPoint] = useState([{ x: 0, y: 0 }])
  const originalPoint = { x: 3, y: 5 };

  const data = [
    swapAxes
      ? { x: originalPoint.y, y: originalPoint.x }
      : originalPoint
  ];
  //#endregion

  //#region UseEffect
  // useEffect(() => {
  //   Image.getSize(
  //     imageUrl,
  //     (width, height) => {
  //       setImageWidth(width);
  //       setImageHeight(height);
  //     },
  //     (error) => {
  //       console.error('Error fetching image size:', error);
  //     }
  //   );
  // }, [imageUrl]);

  useEffect(() => {
    // ! This is run 3x time on load, to figure out why 
    // TODO
    if (isEdit) {
      if (stepsDone === 0) { getCheckedStepsArray(); }
      setSelectedGroup(assm?.assm_group_id);
      setSelectedCompany(assm?.assm_company);
      setSelectedWorkflow(assm?.assm_type);

      // * Calculate total weights 
      let tempSectionWeightTotal = 0;
      let sectionQuestionTotal = [];
      sectionQuestionList?.map((sQItr) => {
        if (sQItr.section_quantitative) {
          setSectionQuant(true)
          sectionQuestionTotal.push(0)
          tempSectionWeightTotal += sQItr.section_weight
          let tempQuestionWeightTotal = 0;
          sQItr.section_questions.map((sQuestItr) => {
            tempQuestionWeightTotal += sQuestItr.question_weight
          })
          sectionQuestionTotal[sQItr.section_order] = tempQuestionWeightTotal
        }

      })
      setQuestionWeightTotal(sectionQuestionTotal);
      setSectionWeightTotal(tempSectionWeightTotal)
    }
    setTempRange({ startDate: assm?.assm_from_date, endDate: assm?.assm_to_date })
  }, [isEdit, assm]);

  const getCheckedStepsArray = () => {
    for (var i = 0; i < sectionQuestionList.length; i++) {
      let stepsString = sectionQuestionList[i].section_rot;
      if (stepsString) {
        const updatedSelectedSteps = [...selectedSteps];
        const stepsArray = stepsString.split(";")?.map((step) => parseInt(step.replace("Step ", ""), 10));
        updatedSelectedSteps[i] = stepsArray
        setSelectedSteps(updatedSelectedSteps);
        setStepsDone(1)
      } else {
        setStepsDone(1)
        return;
      }
    }
  };

  useEffect(() => {
    // * No need to do anything here
  }, [width, height]);

  // * Used for weight totals calculations 
  useEffect(() => {
    // * Caclulate Totals
    // * Section Total 
    // *      Question Totals 
    // *          Question Line int values to be considered towards to totals
    let section_array = [];
    let tempBox = [{ x: 0, y: 0 }]
    sectionQuestionList?.map((singleSection) => {
      if (singleSection.section_quantitative) {
        let section_total = 0;
        let question_array = [];
        singleSection.section_questions.map((singleQuestion, index) => {
          //! Assuming that if weight is existent all the lines contain integer values and no text !
          let question_total = 0;
          if (singleQuestion.question_weight > 0) {
            let line_total = 0;
            singleQuestion.question_lines.map((singleQuestionLine) => {
              // * if boxes translate 1-5 rating to 1-100 Grade
              if (singleQuestionLine.question_line_control === 'boxes') {
                line_total += convertGrade(parseInt(singleQuestionLine.question_line_resp) + 1);
              }
              else {
                line_total += parseInt(singleQuestionLine.question_line_resp) || 0;
              }
            })
            let line_avg = line_total / singleQuestion.question_lines.length;
            // * This graph is only shown when we have boxes questions
            if (singleQuestion.quest_controls === 'boxes') {
              if (index === 0)
                tempBox[0].x = line_avg
              else
                tempBox[0].y = line_avg
            }
            question_total += (line_avg * (singleQuestion.question_weight / 100))
          }
          question_array.push(question_total);
        })
        question_array.map((qrItr) => {
          section_total += qrItr || 0
        })

        let section_avg = section_total / singleSection.section_questions.length
        section_array.push(section_avg * (singleSection.section_weight / 100))
      }
    })
    setSectionPoint(tempBox)
    setSectionWeightTotal(section_array)
  }, [sectionQuestionList]);

  useEffect(() => {
    if (saveForPart === 1) {
      handleSaveAssm();
    }
  }, [saveForPart]);

  useEffect(() => {
    rangeTextRef.current = rangeText;
  }, [rangeText]);

  useEffect(() => {
    rangeRef.current = range;
    if (!datePickerModalOpen && Object.keys(range).length === 2) {
      const hasStartDate = range.startDate && range.startDate.trim() !== '';
      const hasEndDate = range.endDate && range.endDate.trim() !== '';

      if (hasStartDate && hasEndDate) {
        setRangeText(`${changeDateFromYYYYMMDDToDDMMYYYY(range.startDate)} - ${changeDateFromYYYYMMDDToDDMMYYYY(range.endDate)}`);
      } else if (hasStartDate) {
        setRangeText(changeDateFromYYYYMMDDToDDMMYYYY(range.startDate));
      } else {
        setRangeText('');
      }
    };
  }, [range, datePickerModalOpen]);

  useEffect(() => {
    tempRangeRef.current = tempRange;
    setRange(tempRange)
  }, [tempRange]);
  //#endregion

  //#region Helper
  const convertGrade = (grade) => {
    const gradeValue = parseFloat(grade);
    if (gradeValue >= 1 && gradeValue <= 5) {
      return (gradeValue / 5) * 100;
    }
    return 0;
  };
  //#endregion

  //#region Listeners

  //#region Generic Assessment Listeners 
  // ! ----------------------------------------
  const questionType_options = [];
  let uniqueDescriptions = new Set();
  toView === 0 &&
    question_types?.forEach((obj) => {
      if (!uniqueDescriptions.has(obj.control)) {
        questionType_options.push({
          label: obj.control,
          value: obj.assmquestlinetypeid,
        });
        uniqueDescriptions.add(obj.control);
      }
    });

  // ! -----------------------------------------
  const handleGroupChange = (e) => {
    setSelectedGroup(e);
    const list = {
      id: assm?.id,
      assm_group_id: e,
      organization_id: assm?.organization_id,
      assm_title: assm?.assm_title,
      assm_instructions: assm?.assm_instructions,
      assm_from_date: assm?.assm_from_date,
      assm_to_date: assm?.assm_to_date,
      assm_allowChangeOfAppraiser: assm?.assm_allowChangeOfAppraiser,
      assm_type: assm?.assm_type,
      assm_company: assm?.assm_company,
      require_login: true,
    };
    setAssm(list);
  };

  // ! -----------------------------------------
  const company_options = [];
  toView === 0 &&
    company?.forEach((obj) => {
      company_options.push({ label: obj.name, value: obj.company });
    });

  // * Handle change of Company
  const handleCopmanyChange = (e) => {
    setSelectedCompany(e);
    const list = {
      id: assm?.id,
      assm_group_id: assm?.assm_group_id,
      organization_id: assm?.organization_id,
      assm_title: assm?.assm_title,
      assm_instructions: assm?.assm_instructions,
      assm_from_date: assm?.assm_from_date,
      assm_to_date: assm?.assm_to_date,
      assm_allowChangeOfAppraiser: assm?.assm_allowChangeOfAppraiser,
      assm_type: assm?.assm_type,
      assm_company: e,
      require_login: true,
    };
    setAssm(list);
  };

  // ! -----------------------------------------
  const wfl_options = [];
  toView === 0 &&
    workflows?.forEach((obj) => {
      wfl_options.push({ label: obj.description, value: obj.assmType });
    });

  // * Handle change of workflow
  const handleWorkflowChange = (e) => {
    setSelectedWorkflow(e);
    const list = {
      id: assm?.id,
      assm_group_id: assm?.assm_group_id,
      organization_id: assm?.organization_id,
      assm_title: assm?.assm_title,
      assm_instructions: assm?.assm_instructions,
      assm_from_date: assm?.assm_from_date,
      assm_to_date: assm?.assm_to_date,
      assm_allowChangeOfAppraiser: assm?.assm_allowChangeOfAppraiser,
      assm_type: e,
      assm_company: assm?.assm_company,
      require_login: true,
    };
    setAssm(list);
  };

  function HelperCalendar(props) {
    return (
      <CustomCalendar
        calendarType={"RangePicker"}
        setRange={Editable ? setTempRange : () => { }}
        range={tempRange.startDate === '' ? { ...tempRange, startDate: undefined } : tempRange}
      />
    );
  };

  const handleAssmDatesChange = () => {
    const list = {
      id: assm?.id,
      assm_group_id: assm?.assm_group_id,
      organization_id: assm?.organization_id,
      assm_title: assm?.assm_title,
      assm_instructions: assm?.assm_instructions,
      assm_from_date: tempRangeRef.current.startDate,
      assm_to_date: tempRangeRef.current.endDate,
      assm_allowChangeOfAppraiser: assm?.assm_allowChangeOfAppraiser,
      assm_type: assm?.assm_type,
      assm_company: assm?.assm_company,
      require_login: true,
    };
    setAssm(list);
  };

  const onDatePickerModalConfirm = () => {
    setCalendarError("");
    if (tempRangeRef.current.startDate && !tempRangeRef.current.endDate) {
      let newRange = {
        ...tempRange,
        ...{ endDate: tempRangeRef.current.startDate },
      };
      setRange(newRange);
      setDatePickerModalOpen(false);
    } else if (!tempRangeRef.current.startDate) {
      setCalendarError(t("common:errCalendar"));
    } else {
      setRange(tempRangeRef.current);
      setDatePickerModalOpen(false);
    }
    handleAssmDatesChange();
  };

  // ! ----------------------------------------
  // * Go Back to my assessments view
  const handleShowAssessments = () => {
    setShowMyAssessments(1);
    setShowResponseScreen(0);
  };

  //* Save respones, saveFlag=true means the assessment is to be saved,
  //otherwise the assessment is to be submitted
  const handleUpdateResponse = async (saveFlag) => {
    await assm;
    await updateAssessmentResponse(
      clientApi,
      username,
      account.employeeId,
      assmUI,
      assm,
      saveFlag
    ).then((resp) => {
      if (resp.status === 200) {
        showMessage({
          message: saveFlag
            ? t("common:saveSuccess")
            : t("common:submittedSuccess"),
          type: "success",
          duration: 3000,
        });
        handleShowAssessments();
      } else if (resp === 'Required') {
        showMessage({
          message: t("common:questRequired"),
          type: "error",
          duration: 3000,
        });
      }
      else {
        showMessage({
          message: t("common:notSaved"),
          type: "error",
          duration: 3000,
        });
      }
    }).catch(error => {
      showMessage({
        message: t("common:notSaved") + error,
        type: "error",
        duration: 3000,
      });
    })

  };

  // * Change Assessment Title
  const handleAssmTitleChange = (e) => {
    const list = {
      id: assm?.id,
      assm_group_id: assm?.assm_group_id,
      organization_id: assm?.organization_id,
      assm_title: e,
      assm_instructions: assm?.assm_instructions,
      assm_from_date: assm?.assm_from_date,
      assm_to_date: assm?.assm_to_date,
      assm_allowChangeOfAppraiser: assm?.assm_allowChangeOfAppraiser,
      assm_type: assm?.assm_type,
      assm_company: assm?.assm_company,
      require_login: true,
    };
    setAssm(list);
  };

  // * Change assessment instructions
  const handleAssminstructionsChange = (e) => {
    const list = {
      id: assm?.id,
      assm_group_id: assm?.assm_group_id,
      organization_id: assm?.organization_id,
      assm_title: assm?.assm_title,
      assm_instructions: e,
      assm_from_date: assm?.assm_from_date,
      assm_to_date: assm?.assm_to_date,
      assm_allowChangeOfAppraiser: assm?.assm_allowChangeOfAppraiser,
      assm_type: assm?.assm_type,
      assm_company: assm?.assm_company,
      require_login: true,
    };
    setAssm(list);
  };

  // * Change assessment flag to allow change of apraiser
  const handleAssmFlagChange = () => {
    const list = {
      id: assm?.id,
      assm_group_id: assm?.assm_group_id,
      organization_id: assm?.organization_id,
      assm_title: assm?.assm_title,
      assm_instructions: assm?.assm_instructions,
      assm_from_date: assm?.assm_from_date,
      assm_to_date: assm?.assm_to_date,
      assm_allowChangeOfAppraiser: !assm?.assm_allowChangeOfAppraiser,
      assm_type: assm?.assm_type,
      assm_company: assm?.assm_company,
      require_login: true,
    };
    setAssm(list);
  };

  // ! -------------------------------------------------------
  // * Save All Assessment
  const handleSaveAssm = async () => {
    console.log("Saving...");

    let totalWeight = 0;
    let calcTotalWeight = false;

    // * Check Sections are marked for show in graph
    // * 0  - No sections are set for this which is ok
    // * 1  - This is an error 
    // * 2  - This is the correct amount X and Y for graph 
    // * 3+ - All the rest are wrong
    let graphSections = 0;
    let graphYCnt = 0;
    let graphXCnt = 0;
    let showGraphErr = false;
    let graphErrMessage = '';

    // * Check if at least 1 section_quantitative if yes then calculate the total 
    sectionQuestionList.map((sectionItr) => {
      if (sectionItr.section_quantitative) {
        calcTotalWeight = true;
      } else {
        // * If quantitative is false make useOnGraph choise under quantitative also false
        sectionItr.useOnGraph = false;
      }
      if (sectionItr.useOnGraph) {
        // * Increase count 
        graphSections++;
        // * Also count Y and Xs
        if (sectionItr.graphAxis === 'Y')
          graphYCnt++;
        if (sectionItr.graphAxis === 'X')
          graphXCnt++;
      }
    });

    // * If graph data is wrong show error 
    if (graphSections === 1) {
      graphErrMessage = t("common:only1GraphSection")
      showGraphErr = true;
    }
    // * This is the correct
    else if (graphSections === 2) {
      //* Check Y and X must be one of each 
      if (graphXCnt !== 1) {
        graphErrMessage = t("common:graphX")
        showGraphErr = true;
      }
      else if (graphYCnt !== 1) {
        graphErrMessage = t("common:graphY")
        showGraphErr = true;
      }
    }
    else if (graphSections >= 3) {
      graphErrMessage = t("common:only1GraphSection")
      showGraphErr = true;
    }

    // * Show Error for Graph section 
    if (showGraphErr) {
      showMessage({
        message: graphErrMessage,
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    /* Check Weight total = 100 */
    if (calcTotalWeight) {
      sectionQuestionList.map((sectionItr) => {
        totalWeight += sectionItr.section_weight
      })

      if (totalWeight < 100) {
        showMessage({
          message: t("common:weightTotalError"),
          type: "error",
          duration: 3000,
        });
        setShowPartConfirmation(false);
        setSaveForPart(0);
        return;
      }
    }

    /* Check Inserted Assessment Title */
    if (assm?.assm_title == "") {
      showMessage({
        message: t("common:assmTitleError"),
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    /* Check Selected Date */
    if (assm?.assm_from_date == "" || assm?.assm_to_date == "" || assm?.assm_from_date > assm?.assm_to_date) {
      showMessage({
        message: t("common:assmDateError"),
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    /* Check Selected Assessment Workflow */
    if (assm?.assm_type == "") {
      showMessage({
        message: t("common:assmWorkflowError"),
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    /* Check Selected Company */
    if (assm?.assm_company == "") {
      showMessage({
        message: t("common:assmCompanyError"),
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    /* Check Selected Group */
    if (assm?.assm_group_id == "") {
      showMessage({
        message: t("common:assmGroupError"),
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    /* Check Inserted Each Sections Title - Question - Question Type */
    for (var i = 0; i < sectionQuestionList.length; i++) {
      for (var j = 0; j < sectionQuestionList[i].section_questions.length; j++) {
        if (sectionQuestionList[i].section_questions[j].question_name == "") {
          showMessage({
            message: t("common:assmQuestTitleError"),
            type: "error",
            duration: 3000,
          });
          setShowPartConfirmation(false);
          setSaveForPart(0);
          return;
        } else if (sectionQuestionList[i].section_questions[j].input_type_name == "") {
          showMessage({
            message: t("common:assmQuestTypeError"),
            type: "error",
            duration: 3000,
          });
          setShowPartConfirmation(false);
          setSaveForPart(0);
          return;
        }
        for (var k = 0; k < sectionQuestionList[i].section_questions[j].question_lines.length; k++) {
          question_line = sectionQuestionList[i].section_questions[j].question_lines[k];
          if ((question_line.input_type_name === undefined || question_line.input_type_name === '') && sectionQuestionList[i].section_questions[j].input_type_name === 'TCC') {
            showMessage({
              message: t("common:assmQuestLineTypeError"),
              type: "error",
              duration: 3000,
            });
            setShowPartConfirmation(false);
            setSaveForPart(0);
            return;
          }
        }
      }
    }

    // Post Assessment 
    await postAssessment(
      clientApi,
      user.token,
      assm,
      sectionQuestionList,
      username,
      account.employeeId
    )
      .then((response) => {
        if (response) {
          showMessage({
            message: t("common:saveSuccess"),
            type: "success",
            duration: 3000,
          });
          if (importPressed) {
            return true;
          } else if (saveForPart === 1) {
            setAssmUi(assm?.id);
            setWfl(assm?.assm_type)
            setShowParticipationsScreen(1);
            setShowAssessmentsAdmin(0);
            setShowMyAssessments(0);
          } else if (toView) {
            setShowMyAssessments(1);
            setShowAssessmentsAdmin(0);
          } else {
            setShowAssessmentsAdmin(1);
            setShowMyAssessments(0);
          }
          setShowCreateScreen(0);
          setShowEditScreen(0);
          setShowResponseScreen(0);
          setShowCreateGroup(0);
        } else {
          showMessage({
            message: t("common:saveAssmFailMsg"),
            type: "error",
            duration: 3000,
          });
        }
      })
      .catch((error) => {
        showMessage({
          message: t("common:saveGroupError"),
          type: "error",
          duration: 3000,
        });
        if (!isCreate) {
          setShowMyAssessments(1);
        } else {
          setShowAssessmentsAdmin(1);
        }
        setShowCreateScreen(0);
        setShowEditScreen(0);
        setShowEditGroup(0);
        setShowResponseScreen(0);
        setShowCreateGroup(0);
        return false;
      });
  };

  const handleSaveAssmInfo = async () => {
    console.log("Saving...");

    if (assm?.assm_title == "") {
      showMessage({
        message: "Please enter Assessment title",
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    } else if (
      assm?.assm_from_date == "" ||
      assm?.assm_to_date == "" ||
      assm?.assm_from_date > assm?.assm_to_date
    ) {
      showMessage({
        message: "Please enter valid Assessment Dates",
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    } else if (assm?.assm_company == "") {
      showMessage({
        message: "Please enter Assessment Company",
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    } else if (assm?.assm_group_id == "") {
      showMessage({
        message: "Please enter Assessment Group",
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    } else if (assm?.assm_type == "") {
      showMessage({
        message: "Please enter Assessment Workflow",
        type: "error",
        duration: 3000,
      });
      setShowPartConfirmation(false);
      setSaveForPart(0);
      return;
    }

    await SaveAssmInfo(
      clientApi,
      user.token,
      assm,
      username,
      account.employeeId
    )
      .then((response) => {
        showMessage({
          message: "Assessment info successfully saved!",
          type: "success",
          duration: 3000,
        });
        return true;
      })
      .catch((error) => {
        console.log(error)
        showMessage({
          message: "Group failed to save: " + error,
          type: "error",
          duration: 3000,
        });
        return false;
      });
  };

  // Cancel Assessment Creation
  const handleCancelAssm = () => {
    console.log("Cancel..");
    setShowCancelConfirmation(true);
  };

  const handleFinalCancelAssm = (flag) => {
    if (flag) {
      console.log("Cancel...")
      if (toView) setShowMyAssessments(1);
      else setShowAssessmentsAdmin(1);
      setShowResponseScreen(0);
      setShowCreateScreen(0);
      setShowCreateGroup(0);
      setShowEditScreen(0);
      setShowEditGroup(0);
    } else {
      setShowCancelConfirmation(false);
    }
  };

  const isSectionEmpty = () => {
    const missingFields = sectionQuestionList.some((section) => {
      return (
        section.section_name === "" &&
        section.section_questions.some((question) => {
          return (
            question.question_name === "" &&
            (question.question_lines.some(
              (line) => line.question_line_description === ""
            ))
          );
        })
      );
    });
    if (missingFields) {
      setSectionEmpty(true);
    } else { setSectionEmpty(false); }
  };
  //#endregion

  //#region Section
  // ! --------------------------------------------------------
  // * Add new Section
  const handleSectionAdd = (index) => {
    let addQuestTotal = [...questionWeightTotal]
    addQuestTotal.push(0)
    setQuestionWeightTotal(addQuestTotal)
    // Add question total for weight in every 
    var qId = generateUniqueID();
    setSectionQuestionList([
      ...sectionQuestionList,
      {
        id: generateUniqueID(),
        assm_header_id: "",
        section_name: "",
        section_order: index + 1,
        section_instuctions: "",
        section_url_img: "",
        isSectionCover: false,
        graphAxis: "",
        useOnGraph: false,
        section_required_yn: 0,
        section_quantitative: false,
        section_showResults: false,
        section_hideComparison: false,
        section_rotw: "",
        section_weight: 0,
        section_questions: [
          {
            id: qId,
            parent_id: "",
            survey_section_id: "",
            input_type_id: generateUniqueID(),
            input_type_name: "",
            quest_instructions: "",
            question_name: "",
            question_subtext: "",
            question_required_yn: 0,
            answer_required_yn: 0,
            option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
            allow_mutiple_option_answers_yn: 0,
            dependent_question_id: generateUniqueID(),
            dependent_question_option_id: generateUniqueID(),
            dependent_answer_id: generateUniqueID(),
            question_order: 0,
            question_weight: 0,
            questImgUrl: "",
            isQuestionCover: false,
            question_options: [
              {
                id: generateUniqueID(),
                question_id: qId,
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 0,
              },
            ],
            question_lines: [
              {
                id: generateUniqueID(),
                question_id: qId,
                question_line_description: "",
                question_line_order: 0,
                question_line_required_yn: false,
                input_type_id: generateUniqueID(),
                input_type_name: "",
                weight: 0,
              },
            ],
          },
        ],
      },
    ]);
  };

  // * Handle any section changes
  const handleSectionChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].section_name = e;
    list[index].section_order = index;
    list[index].section_header_id = assm?.id;
    setSectionQuestionList(list);
  };

  // * Handle instructions section changes
  const handleSectionInstructionsChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].section_instructions = e;
    setSectionQuestionList(list);
  };

  const handleSectionUrlImgChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].section_url_img = e;
    setSectionQuestionList(list);
  };

  const handleIsSectionCoverChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].isSectionCover = !list[index].isSectionCover;
    setSectionQuestionList(list);
  }

  // * Graph Listeners - Only allow X or Y or '' for deleting all contents 
  const handleGraphAxisChange = (e, index) => {
    let axis = String(e)
    if (axis !== 'Y' && axis !== 'X' && axis !== '') {
      return;
    }
    const list = [...sectionQuestionList];
    list[index].graphAxis = axis;
    setSectionQuestionList(list);
  };

  const handleUseOnGraphChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].useOnGraph = !list[index].useOnGraph;
    setSectionQuestionList(list);
  }

  // * Handle instructions section changes
  const handleSectionQuantitativeChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].section_quantitative = !list[index].section_quantitative;
    setSectionQuestionList(list);

    //* Check if at least one section quantative to show the section % total 
    for (var sectionItr = 0; sectionItr < list.length; sectionItr++) {
      if (list[sectionItr].section_quantitative) {
        setSectionQuant(true);
        break;
      }
      else
        setSectionQuant(false)

    }
  };

  const handleSectionShowResultsChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].section_showResults = !list[index].section_showResults;
    setSectionQuestionList(list);
  };

  const handleSectionStepsChange = (e, index) => {
    const list = [...sectionQuestionList];
    const str = getCheckedStepsString(index);
    list[index].section_rotw = str;
    setSectionQuestionList(list);
  };

  const getCheckedStepsString = (index) => {
    if (selectedSteps[index]) {
      return selectedSteps[index]
        .sort((a, b) => a - b)
        .map((step) => `Step ${step}`)
        .join(";");
    } else {
      return "";
    }
  };

  const handleSectionHideComparisonChange = (e, index) => {
    const list = [...sectionQuestionList];
    list[index].section_hideComparison = !list[index].section_hideComparison;
    setSectionQuestionList(list);
  };

  // * Handle instructions section changes
  const handleSectionWeightChange = (e, indx) => {
    // * Regex non numeric charactes and change them to empty string 
    let input = e.replace(/[^0-9]/g, '')
    if (input !== '') {
      //* Weight only between 1-100% 
      if (Number(input) > 100)
        input = 100
      else if (Number(input) < 1)
        input = 0
    } else { input = 0 }
    const list = [...sectionQuestionList];
    // * If section total > 100 % then show an error to the user and not update the TextInput
    let totalWeight = 0;
    list.map((listItr, index) => {
      if (index !== indx)
        totalWeight += listItr.section_weight;
    })
    if (totalWeight + Number(input) > 100) {
      //! This is not showing because of card elevation that is apparently shown on top of everything 
      showMessage({
        message: "Weight cannot be greater than 100%",
        type: "error",
        duration: 3000,
      })
      //! Work arount set a true false state and show a message in all weights 
      setWeightMessage(true)
    }
    else {
      // * If all is good assign the new value
      list[indx].section_weight = (Number(input));
      setSectionQuestionList(list);
    }

    let tempSectionWeight = 0;
    list.map((sectionItr) => {
      tempSectionWeight += sectionItr.section_weight;
    })
    setSectionWeightTotal(tempSectionWeight);
  };

  // * Remove Specific Section
  const handleSectionRemove = (index) => {
    const list = [...sectionQuestionList];
    list.splice(index, 1);
    list?.map((itr, index) => (itr.section_order = index));
    removeSection(sectionQuestionList[index].id)
    setSectionQuestionList(list);
  };

  const removeSection = (sectionUI) => {
    removeSectionFromUI(clientApi, user.token, username, sectionUI)
      .then((resp) => {
      })
      .catch((error) => {
        console.error(error);
      });
  }
  //#endregion

  //#region Question
  // ! -----------------------------------------------------------
  // * add question
  const handleQuestionAdd = (index, sectionIndex) => {
    var qId = generateUniqueID();
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: [
              ...sQItr.section_questions,
              {
                id: qId,
                parent_id: "",
                assm_section_id: "",
                input_type_id: generateUniqueID(),
                input_type_name: "",
                question_name: "",
                question_subtext: "",
                question_required_yn: 0,
                answer_required_yn: 0,
                option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                allow_mutiple_option_answers_yn: 0,
                dependent_question_id: generateUniqueID(),
                dependent_question_option_id: generateUniqueID(),
                dependent_answer_id: generateUniqueID(),
                question_order: index + 1,
                question_weight: 0,
                quest_instructions: "",
                question_options: [
                  {
                    id: generateUniqueID(),
                    question_id: qId,
                    fk_option_choice_id:
                      "AFD27943-922E-4A41-B267-09BC39942F63",
                    fk_option_choice_name: "",
                    question_option_name: "",
                    option_order: 0,
                  },
                ],
                question_lines: [
                  {
                    id: generateUniqueID(),
                    question_id: qId,
                    question_line_description: "",
                    question_line_order: 0,
                    question_line_required_yn: false,
                    input_type_id: generateUniqueID(),
                    input_type_name: "",
                    weight: 0,
                  },
                ],
              },
            ],
          }
          : { ...sQItr }
      )
    );
  };

  // * Add quetion to the assessment
  const handleQuestionAddFromAssessment = (
    index,
    sectionIndex,
    selectedQuestion
  ) => {
    var qId = generateUniqueID();
    var listOfOptions = [];
    selectedQuestion.question_options?.map(
      (option) =>
      (listOfOptions = [
        ...listOfOptions,
        {
          ...option,
          id: generateUniqueID(),
          question_id: qId,
          fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
          fk_option_choice_name: "",
        },
      ])
    );
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: [
              ...sQItr.section_questions,
              {
                id: qId,
                parent_id: sQItr.id,
                assm_section_id: sQItr.id,
                input_type_id: generateUniqueID(),
                input_type_name: selectedQuestion.input_type_name,
                question_name: selectedQuestion.question_name,
                question_subtext: selectedQuestion.question_subtext,
                question_required_yn: selectedQuestion.question_required_yn,
                answer_required_yn: selectedQuestion.answer_required_yn,
                option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
                allow_mutiple_option_answers_yn:
                  selectedQuestion.allow_mutiple_option_answers_yn,
                dependent_question_id: generateUniqueID(),
                dependent_question_option_id: generateUniqueID(),
                dependent_answer_id: generateUniqueID(),
                question_order: index + 1,
                question_weight: selectedQuestion.question_weight,
                question_options: [...listOfOptions],
              },
            ],
          }
          : { ...sQItr }
      )
    );
  };

  // * Remove Question from the assessment
  const handleQuestionRemove = (index, sectionIndex) => {
    const list = [...sectionQuestionList[sectionIndex].section_questions];
    list.splice(index, 1);
    list?.map((itr, index) => (itr.question_order = index));
    removeQuestion(sectionQuestionList[sectionIndex].section_questions[index].id)
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: list,
          }
          : { ...sQItr }
      )
    );
  };

  const handleQuestionTypeChange = (val, index, sectionIndex) => {
    const list = [
      ...sectionQuestionList[sectionIndex].section_questions[index]
        .question_options,
    ];
    const item = list.splice(0, 1);
    const qId = sectionQuestionList[sectionIndex].section_questions[index].id;
    const Ratinglist = [
      {
        id: generateUniqueID(),
        question_id: qId,
        fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
        fk_option_choice_name: "",
        question_option_name: "",
        option_order: 0,
      },
      {
        id: generateUniqueID(),
        question_id: qId,
        fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
        fk_option_choice_name: "",
        question_option_name: "",
        option_order: 1,
      },
      {
        id: generateUniqueID(),
        question_id: qId,
        fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
        fk_option_choice_name: "",
        question_option_name: "",
        option_order: 2,
      },
      {
        id: generateUniqueID(),
        question_id: qId,
        fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
        fk_option_choice_name: "",
        question_option_name: "",
        option_order: 3,
      },
      {
        id: generateUniqueID(),
        question_id: qId,
        fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
        fk_option_choice_name: "",
        question_option_name: "",
        option_order: 4,
      },
    ];
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map(
              (section_questions) =>
                section_questions.question_order === index
                  ? {
                    ...section_questions,
                    input_type_name: val,
                    question_lines: section_questions.question_lines?.map(
                      (questionLine) => ({
                        ...questionLine,
                        input_type_name: val === "TCC" ? undefined : val,
                      })
                    ),
                    question_options: val === "TCC" ? Ratinglist : item,
                  }
                  : { ...section_questions }
            ),
          }
          : { ...sQItr }
      )
    );
  };

  // * Finding the section from the index passed and then the question to edit on the particular question element
  const handleQuestionChange = (
    qName = '',
    questionId,
    sectionId,
    sectionIndex,
    isAllowMultipleAnswers = 0,
    isRequired = 0,
    weight = -1,
    questImgUrl = undefined,
    isQuestionCover = undefined,
  ) => {
    let allowMultAns = 0;
    let question_required = 0;

    // * If weight = -1 means that question name is changed. This is nescessary to avoid duplicated code and update all the question elements from here
    // If isAllowMutliple answer convert value to 0 or 1
    if (isAllowMultipleAnswers) {
      if (e === true)
        allowMultAns = 1;
      else allowMultAns = 0;
    }

    // If isRequired answer convert value to 0 or 1
    if (isRequired) {
      if (qName === true)
        question_required = 1;
      else question_required = 0;
    }
    let tempQuestionChange = sectionQuestionList?.map((sQItr) =>
      sQItr.id === sectionId
        ? {
          ...sQItr,
          section_questions: sQItr.section_questions?.map(
            (section_questions) =>
              section_questions.id === questionId
                ? {
                  ...section_questions,
                  question_name:
                    !isAllowMultipleAnswers && !isRequired && weight == -1 && isQuestionCover == undefined && questImgUrl == undefined
                      ? qName
                      : section_questions.question_name,
                  parent_id: sectionId,
                  assm_section_id: sectionId,
                  allow_mutiple_option_answers_yn: isAllowMultipleAnswers
                    ? allowMultAns
                    : section_questions.allow_mutiple_option_answers_yn,
                  question_required_yn: isRequired
                    ? question_required
                    : section_questions.question_required_yn,
                  questImgUrl: questImgUrl !== undefined
                    ? questImgUrl
                    : section_questions.questImgUrl,
                  isQuestionCover: isQuestionCover !== undefined
                    ? isQuestionCover
                    : section_questions.isQuestionCover,
                  question_weight: Number(weight) >= 0 && qName == ''
                    ? Number(weight) :
                    section_questions.question_weight,
                }
                : { ...section_questions }
          ),
        }
        : { ...sQItr }
    )

    setSectionQuestionList(
      tempQuestionChange
    );

    let totalSection = 0;
    // * If weight question change then change the section question totals 
    if (weight >= 0) {
      tempQuestionChange?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map(
              (section_questions) => {
                totalSection += section_questions.question_weight
              }
            ),
          }
          : { ...sQItr }
      )

      let qTotal = questionWeightTotal
      qTotal[sectionIndex] = totalSection
      setQuestionWeightTotal(qTotal)
    }
  };

  // * Handle changes of the instructions for a question
  const handleQuestInstructionsChange = (
    e,
    index,
    sectionIndex,
    isAllowMultipleAnswers = 0,
    isRequired = 0
  ) => {
    // If isAllowMutliple answer convert value to 0 or 1
    if (isAllowMultipleAnswers) {
      if (e === true)
        //value === 'on'
        allowMultAns = 1;
      else allowMultAns = 0;
    }

    // If isRequired answer convert value to 0 or 1
    if (isRequired) {
      if (e === true)
        //value === 'on'
        question_required = 1;
      else question_required = 0;
    }
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map(
              (section_questions) =>
                section_questions.question_order === index
                  ? {
                    ...section_questions,
                    quest_instructions:
                      !isAllowMultipleAnswers && !isRequired
                        ? e
                        : section_questions.quest_instructions,
                  }
                  : { ...section_questions }
            ),
          }
          : { ...sQItr }
      )
    );
  };

  const removeQuestion = (questionUI) => {
    removeQuestionFromUI(clientApi, user.token, username, questionUI)
      .then((resp) => {
      })
      .catch((error) => {
        console.error(error);
      });
  }
  //#endregion

  //#region  Question Line
  // * Add Question line
  const handleQuestionLineAdd = (index, sectionIndex, questionIndex) => {
    const updatedSectionQuestionList = sectionQuestionList?.map(
      (section, sIndex) => {
        if (sIndex === sectionIndex) {
          return {
            ...section,
            section_questions: section.section_questions?.map(
              (question, qIndex) => {
                if (qIndex === questionIndex) {
                  return {
                    ...question,
                    question_lines: [
                      ...question.question_lines,
                      {
                        id: generateUniqueID(),
                        question_id: "",
                        question_line_description: "",
                        question_line_order: index + 1,
                        question_line_required_yn: false,
                        input_type_id: generateUniqueID(),
                        input_type_name: "",
                        weight: 0,
                      },
                    ],
                  };
                }
                return question;
              }
            ),
          };
        }
        return section;
      }
    );
    setSectionQuestionList(updatedSectionQuestionList);
  };

  // * Finding the section from the index passed and then the question to edit on the particular section
  const handleQuestionLineChange = (
    desc,
    type,
    respText,
    respNumeric,
    isRequired = 0,
    isWeight = 0,
    sectionIndex,
    questionIndex,
    index
  ) => {
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map(
              (section_questions) =>
                section_questions.question_order === questionIndex
                  ? {
                    ...section_questions,
                    question_lines: section_questions.question_lines?.map(
                      (qoItr) =>
                        qoItr.question_line_order === index
                          ? {
                            ...qoItr,
                            question_line_description:
                              !isRequired && !isWeight
                                ? desc
                                : qoItr.question_line_description,
                            input_type_name:
                              type === ""
                                ? qoItr.input_type_name
                                : type,
                            question_line_required_yn:
                              isRequired && !isWeight
                                ? isRequired
                                : qoItr.question_line_required_yn,
                            weight: isWeight ? isWeight : qoItr.weight,
                          }
                          : { ...qoItr }
                    ),
                  }
                  : { ...section_questions }
            ),
          }
          : { ...sQItr }
      )
    );
  };

  // * Handle responses for a questionLine
  const handleQuestionLineResp = (resp, question_line_id, section_id, question_id) => {
    let tempAssm = assm;
    let updatedAssmSections = tempAssm?.sectionQuestionList?.map((sQItr) =>
      sQItr.id === section_id
        ? {
          ...sQItr,
          section_questions: sQItr.section_questions?.map(
            (section_questions) =>
              section_questions.id === question_id
                ? {
                  ...section_questions,
                  question_lines: section_questions.question_lines?.map(
                    (qoItr) =>
                      qoItr.question_line_respUI === question_line_id
                        ? {
                          ...qoItr,
                          question_line_resp: resp
                        }
                        : { ...qoItr }
                  ),
                }
                : { ...section_questions }
          ),
        }
        : { ...sQItr }
    )

    tempAssm?.sectionQuestionList.splice(0, tempAssm?.sectionQuestionList.length, ...updatedAssmSections)
    // ! Recreating the array not sure if its needed my remove later 
    // TODO 
    let arrAssm = [];
    let len = allAssm.length
    for (let assmItr = 0; assmItr < len - 1; assmItr++) {
      arrAssm.push(allAssm[assmItr])
    }
    arrAssm?.push(tempAssm)
    setAssm(arrAssm)
  }

  // * Add a new set of question lines in the case of Qustion Type is TableCustomControls
  const handleTccQuestionLineAdd = (section_id, question_id) => {
    let tccObjectsToAdd = [];
    let tAssm = assm;

    // Find the original question lines for the question to get the base sequence of question_ids
    const originalQuestionLines = tAssm?.sectionQuestionList
      ?.find(section => section.id === section_id)
      ?.section_questions?.find(q => q.id === question_id)
      ?.question_lines || [];
    // Extract the original question_id sequence (e.g., [0,1,2,3])
    const originalQuestionIds = originalQuestionLines.map(ql => ql.question_id);

    tccObjects?.map((tccItr) => {
      if (tccItr.questUI === question_id)
        tccItr.tccArr?.map((itr, index) => {
          let tcc = {
            id: itr.id,
            question_id: originalQuestionIds[index] !== undefined ? originalQuestionIds[index] : index,
            question_line_description: itr.question_line_description,
            question_line_questUI: itr.question_line_questUI,
            question_line_valuelist: itr.question_line_valuelist,
            question_line_order: 0,
            question_line_instructions: itr.question_line_instructions,
            question_line_control: itr.question_line_control,
            question_line_assm_quest_line_type_id: 2,
            question_line_resp: '',
            question_line_respUI: generateUniqueID(),
            has_assmresp: 0,
          }

          tccObjectsToAdd.push(tcc)
        })
    })

    let updatedAssmSections = tAssm?.sectionQuestionList?.map((sQItr) =>
      sQItr.id === section_id
        ? {
          ...sQItr,
          section_questions: sQItr.section_questions?.map(
            (section_questions) =>
              section_questions.id === question_id
                ? {
                  ...section_questions,

                  question_lines: [...section_questions.question_lines, ...tccObjectsToAdd],
                }
                : { ...section_questions }
          ),
        }
        : { ...sQItr }
    )
    tAssm?.sectionQuestionList.splice(0, tAssm?.sectionQuestionList.length, ...updatedAssmSections)
    // ! Recreating the array not sure if its needed my remove later 
    // TODO 
    let arrAssm = [];
    // * There is always 1 assessment in allAssm, in WFL7 VIew Previews there are 
    // * 2 assessments because the appraisee can view the appraiser submitted assessment
    arrAssm?.push(allAssm[0])
    if (allAssm[1] !== undefined)
      arrassm?.push(tAssm)
    setAssm(arrAssm)

  }

  // * Remove a set of question lines in the case of Qustion Type is TableCustomControls
  const handleDeleteTccAnswerGroup = (section_id, lastIndex, groupLength) => {
    let tAssm = assm;
    // Calculate start index of the answer question lines
    const startIndex = lastIndex - (groupLength - 1);

    // Map through sectionQuestionList to find the matching section
    let updatedAssmSections = tAssm?.sectionQuestionList?.map((section) =>
      section.id === section_id
        ? {
          ...section,
          section_questions: section.section_questions?.map((question) => {
            if (!question.question_lines) return question;

            // Remove the block of question lines from startIndex to lastIndex inclusive
            const updatedQuestionLines = [
              ...question.question_lines.slice(0, startIndex),
              ...question.question_lines.slice(lastIndex + 1),
            ];

            return {
              ...question,
              question_lines: updatedQuestionLines,
            };
          }),
        }
        : { ...section }
    );

    // Replace the sectionQuestionList with the updated one
    tAssm?.sectionQuestionList.splice(0, tAssm?.sectionQuestionList.length, ...updatedAssmSections);

    // Recreate the array of assessments
    let arrAssm = [];
    arrAssm.push(allAssm[0]);
    if (allAssm[1] !== undefined) arrAssm.push(tAssm);

    setAssm(arrAssm);
  };

  // * Remove Question Line from the assessment
  const handleQuestionLineRemove = (index, questionIndex, sectionIndex) => {
    const list = [
      ...sectionQuestionList[sectionIndex].section_questions[questionIndex]
        .question_lines,
    ];
    list.splice(index, 1);
    list?.map((itr, index) => (itr.question_line_order = index));
    removeQuestionLine(sectionQuestionList[sectionIndex].section_questions[questionIndex].question_lines[index].id)
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map(
              (sectionQuestion, qIndex) =>
                qIndex === questionIndex
                  ? {
                    ...sectionQuestion,
                    question_lines: list,
                  }
                  : sectionQuestion
            ),
          }
          : { ...sQItr }
      )
    );
  };

  const removeQuestionLine = (questionLineUI) => {
    removeQuestionLineFromUI(clientApi, user.token, username, questionLineUI)
      .then((resp) => {
      })
      .catch((error) => {
        console.error(error);
      });
  }

  //#endregion

  // * Question range options for subquestion Agree/Disagree
  const handleQuestionRatingOptionChange = (
    e,
    input_type_name,
    question_option_id,
    isResponse = 1,
    sectionIndex,
    questionIndex,
    index,
    allow_mutiple_option_answers_yn = 0,
    questionId
  ) => {
    // * If response then save on the table
    if (isResponse) {
      // * If not allow mutliple answers get all the option ids to disable
      var tempOptions = [];
      if (allow_mutiple_option_answers_yn === 0) {
        sectionQuestionList?.map((sQItr) => {
          if (sQItr.section_order === sectionIndex) {
            sQItr.section_questions?.map((section_questions) => {
              if (section_questions.question_order === questionIndex) {
                section_questions.question_options?.map((qoItr) => {
                  if (
                    Math.floor(qoItr.option_order / 6) === Math.floor(index / 6)
                  )
                    if (qoItr.id !== question_option_id) {
                      tempOptions.push(qoItr.id);
                    }
                });
              }
            });
          }
        });
      }
      setQuestionOptionResponseList(
        questionOptionResponseList?.map((qOItr) =>
          tempOptions.includes(qOItr.question_option_id) &&
            input_type_name === "Rating Options"
            ? {
              ...qOItr,
              answer_yn: 0,
            }
            : qOItr.question_option_id === question_option_id &&
              input_type_name === "Rating Options"
              ? {
                ...qOItr,
                answer_yn: 1,
              }
              : { ...qOItr }
        )
      );
    } else {
      setSectionQuestionList(
        sectionQuestionList?.map((sQItr) =>
          sQItr.section_order === sectionIndex
            ? {
              ...sQItr,
              section_questions: sQItr.section_questions?.map(
                (section_questions) =>
                  section_questions.question_order === questionIndex
                    ? {
                      ...section_questions,
                      question_options:
                        section_questions.question_options?.map((qoItr) =>
                          Math.floor(qoItr.option_order / 6) ===
                            Math.floor(index / 6)
                            ? { ...qoItr, question_option_name: e }
                            : { ...qoItr }
                        ),
                    }
                    : { ...section_questions }
              ),
            }
            : { ...sQItr }
        )
      );
    }
  };

  // * Question options range add subquestion
  const handleQuestionRatingOptionAdd = (
    index,
    sectionIndex,
    questionIndex,
    questionId
  ) => {
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map(
              (section_questions) =>
                section_questions.question_order === questionIndex
                  ? {
                    ...section_questions,
                    question_options: [
                      ...section_questions.question_options,
                      {
                        id: generateUniqueID(),
                        question_id: questionId,
                        fk_option_choice_id:
                          "AFD27943-922E-4A41-B267-09BC39942F63",
                        fk_option_choice_name: "",
                        question_option_name: "",
                        option_order: index + 1,
                      },
                      {
                        id: generateUniqueID(),
                        question_id: questionId,
                        fk_option_choice_id:
                          "AFD27943-922E-4A41-B267-09BC39942F63",
                        fk_option_choice_name: "",
                        question_option_name: "",
                        option_order: index + 2,
                      },
                      {
                        id: generateUniqueID(),
                        question_id: questionId,
                        fk_option_choice_id:
                          "AFD27943-922E-4A41-B267-09BC39942F63",
                        fk_option_choice_name: "",
                        question_option_name: "",
                        option_order: index + 3,
                      },
                      {
                        id: generateUniqueID(),
                        question_id: questionId,
                        fk_option_choice_id:
                          "AFD27943-922E-4A41-B267-09BC39942F63",
                        fk_option_choice_name: "",
                        question_option_name: "",
                        option_order: index + 4,
                      },
                      {
                        id: generateUniqueID(),
                        question_id: questionId,
                        fk_option_choice_id:
                          "AFD27943-922E-4A41-B267-09BC39942F63",
                        fk_option_choice_name: "",
                        question_option_name: "",
                        option_order: index + 5,
                      },
                      {
                        id: generateUniqueID(),
                        question_id: questionId,
                        fk_option_choice_id:
                          "AFD27943-922E-4A41-B267-09BC39942F63",
                        fk_option_choice_name: "",
                        question_option_name: "",
                        option_order: index + 6,
                      },
                    ],
                  }
                  : { ...section_questions }
            ),
          }
          : { ...sQItr }
      )
    );
  };

  const handleQuestionRatingOptionRemove = (
    index,
    sectionIndex,
    questionIndex
  ) => {
    const list = [
      ...sectionQuestionList[sectionIndex].section_questions[questionIndex]
        .question_options,
    ];
    list.splice(index - 5, 6);
    list?.map((itr, index) => (itr.option_order = index));
    setSectionQuestionList(
      sectionQuestionList?.map((sQItr) =>
        sQItr.section_order === sectionIndex
          ? {
            ...sQItr,
            section_questions: sQItr.section_questions?.map((SQO) =>
              SQO.question_order === questionIndex
                ? {
                  ...SQO,
                  question_options: list,
                }
                : { ...SQO }
            ),
          }
          : { ...sQItr }
      )
    );
  };

  // * Finding the section from the index passed and then the question to edit on the particular section
  const handleQuestionOptionChange = (
    val,
    input_type_name,
    question_option_id,
    isResponse = 1,
    sectionIndex,
    questionIndex,
    index,
    allow_mutiple_option_answers_yn = 0,
    questionId
  ) => {
    // * If response then save on the table
    if (isResponse) {
      // * If not allow mutliple answers get all the option ids to disable
      var tempOptions = [];
      if (allow_mutiple_option_answers_yn === 0) {
        sectionQuestionList?.map((sQItr) => {
          if (sQItr.section_order === sectionIndex) {
            sQItr.section_questions?.map((section_questions) => {
              if (section_questions.question_order === questionIndex) {
                section_questions.question_options?.map((qoItr) => {
                  if (qoItr.id !== question_option_id) {
                    tempOptions.push(qoItr.id);
                  }
                });
              }
            });
          }
        });
      }
      setQuestionOptionResponseList(
        questionOptionResponseList?.map((qOItr) =>
          qOItr.question_option_id === question_option_id &&
            input_type_name === "True/False Options"
            ? {
              ...qOItr,
              answer_yn:
                qOItr.answer_yn === 2 || qOItr.answer_yn === 0 ? 1 : 0,
            }
            : qOItr.question_option_id === question_option_id &&
              input_type_name === "Text"
              ? {
                ...qOItr,
                answer_text: val,
                answer_yn: 0,
              }
              : qOItr.question_option_id === question_option_id &&
                (input_type_name === "Slider" ||
                  input_type_name === "Boxes" ||
                  input_type_name === "Rating(10)" ||
                  input_type_name === "Rating(5)")
                ? {
                  ...qOItr,
                  answer_numeric: val,
                  answer_yn: 0,
                }
                : tempOptions.includes(qOItr.question_option_id) &&
                  allow_mutiple_option_answers_yn === 0 &&
                  input_type_name === "Options"
                  ? {
                    ...qOItr,
                    answer_yn: 0,
                  }
                  : qOItr.question_option_id === question_option_id &&
                    allow_mutiple_option_answers_yn === 0 &&
                    input_type_name === "Options"
                    ? {
                      ...qOItr,
                      answer_yn: 1,
                    }
                    : qOItr.question_option_id === question_option_id &&
                      input_type_name === "Options" &&
                      allow_mutiple_option_answers_yn === 1
                      ? {
                        ...qOItr,
                        answer_yn:
                          qOItr.answer_yn === 2 || qOItr.answer_yn === 0 ? 1 : 0,
                      }
                      : { ...qOItr }
        )
      );
    } else {
      setSectionQuestionList(
        sectionQuestionList?.map((sQItr) =>
          sQItr.section_order === sectionIndex
            ? {
              ...sQItr,
              section_questions: sQItr.section_questions?.map(
                (section_questions) =>
                  section_questions.question_order === questionIndex
                    ? {
                      ...section_questions,
                      question_options:
                        section_questions.question_options?.map((qoItr) =>
                          qoItr.option_order === index
                            ? { ...qoItr, question_option_name: val }
                            : { ...qoItr }
                        ),
                    }
                    : { ...section_questions }
              ),
            }
            : { ...sQItr }
        )
      );
    }
  };

  const handleAddParticipations = () => {
    setShowPartConfirmation(true);
  };

  const handleFinalPartAssm = (flag) => {
    if (flag) {
      setSaveForPart(1);
    } else {
      setShowPartConfirmation(false);
    }
  };
  //#endregion

  // * When Loading Responses show nothing 
  if (isLoading) {
    return (
      <SafeAreaView
        style={styles.main}>
        <ActivityIndicator animating={true} size='large' color="#86BC25" />

      </SafeAreaView>
    )
  }
  // console.log(sectionQuestionList)
  return (
    <SafeAreaView style={styles.rowContainer}>
      {/* // * Table of contents */}
      {(toView == 1 && resultIndx === 0) &&
        <SafeAreaView style={styles.rowSubContainer}>
          <ScrollView contentContainerStyle={styles.supportContainer}>
            <CustomLabel
              value={t("common:assmTableOfContents")}
              type="ASSM_MARGHOR"
              style={styles.title}
            />
            <View style={styles.line} />
            {/* ScrollView only for the section/question list */}
            <ScrollView>
              {sectionQuestionList?.map((singleSection, index) => {
                if (singleSection.isSectionCover || !singleSection.section_name) return null;
                return (
                  <SafeAreaView key={index} style={styles.sectionContainer}>
                    <SafeAreaView style={styles.column}>
                      <CustomButton
                        text={singleSection.section_name}
                        onPress={() => { }}
                        type="CONTENTS_SECTION"
                      />
                    </SafeAreaView>
                    <SafeAreaView style={styles.column}>
                      {singleSection.section_questions.map((singleQuestion, qIndex) => {
                        if (!singleQuestion.question_name || singleQuestion.question_name.trim() === '') return null;
                        return (
                          <CustomButton
                            key={qIndex}
                            text={`→ ${singleQuestion.question_name}`}
                            onPress={() => { }}
                            type="CONTENTS"
                          />
                        );
                      })}
                    </SafeAreaView>
                  </SafeAreaView>
                );
              })}
            </ScrollView>
            {/* //* Print the weight totals if possible  */}
            {sectionWeightTotal.length > 0 && !showDetails &&
              <SafeAreaView>
                <View style={styles.line} />
                <CustomLabel
                  value={t("common:assmWeight")}
                  type="ASSM_MARGHOR"
                />
                {sectionQuestionList?.map((singleSection, index) => {
                  return (
                    <SafeAreaView>
                      <SafeAreaView style={styles.row}>
                        {
                          !singleSection.isSectionCover &&
                          <CustomLabel
                            value={singleSection.section_name === "" || singleSection.section_name === undefined ? "" : singleSection.section_name}
                            // onPress={() => { }}
                            type="ASSM"
                          />
                        }
                        {/* //* out of 10 so converting back to out of 100 % */}
                        {
                          !singleSection.isSectionCover &&
                          <CustomLabel
                            value={Number(sectionWeightTotal[index] * 10).toFixed(2) + '%'}
                            type="ASSM"
                          />
                        }
                      </SafeAreaView>
                      {(sectionPoint[0].x !== 0 && sectionPoint[0].y !== 0) &&
                        <VictoryChart domain={{ x: [0, 100], y: [0, 100] }}>
                          <VictoryAxis dependentAxis />
                          <VictoryAxis />
                          <VictoryScatter
                            data={sectionPoint}
                            size={7}
                            style={{ data: { fill: '#c43a31' } }}
                          />
                        </VictoryChart>}
                    </SafeAreaView>
                  )
                })}
              </SafeAreaView>
            }
          </ScrollView>
        </SafeAreaView >
      }
      <SafeAreaView style={styles.rowMainContainer}>
        <ScrollView contentContainerStyle={styles.mainContainer}>
          {/* //* Results Extra Data */}
          {showDetails &&
            <Card style={styles.cardstyle}>
              <Card.Actions>
                <CustomButton
                  text={showExtraData ? t('common:hideExtraData') : t('common:showExtraData')}
                  onPress={() => { setShowExtraData(!showExtraData) }}
                  iconName={showExtraData ? "chevron-down-outline" : "chevron-forward-outline"}
                  show="HOME"
                  type="HOME"
                  textTop="0"
                  sz={25}
                />
              </Card.Actions>
              {showExtraData && <Card.Content>
                <CustomLabel
                  value={t("common:appraisername") + ' : ' + assm.assm_appraiser}
                  type="ASSM"
                />
                <CustomLabel
                  value={t("common:appraiseename") + ' : ' + assm.assm_appraisee}
                  type="ASSM"
                />
                <CustomLabel
                  value={t("common:stage") + assm.assm_stage}
                  type="ASSM"
                />
                {sectionWeightTotal !== [] && showDetails &&
                  <SafeAreaView>
                    <CustomLabel
                      value={t("common:assmWeight")}
                      type="ASSM"
                    />
                    {sectionQuestionList?.map((singleSection, index) => {
                      return (
                        <SafeAreaView style={styles.row}>
                          <CustomButton
                            text={singleSection.section_name === "" || singleSection.section_name === undefined ? "" : singleSection.section_name}
                            onPress={() => { }}
                            type="CONTENTS"
                          />
                          {/* //* out of 10 so converting back to out of 100 % */}
                          <CustomLabel
                            value={Number(sectionWeightTotal[index] * 10).toFixed(2) + '%'}
                            type="ASSM"
                          />
                        </SafeAreaView>
                      )
                    })}
                  </SafeAreaView>
                }
              </Card.Content>}
            </Card>
          }

          {/* //* Assesment Title */}
          {!isPreview && <Card style={styles.cardstyle}>
            <Card.Content>
              <CustomInput
                value={assm?.assm_title === "" || assm?.assm_title === undefined ? "" : assm?.assm_title}
                editable={toView == 1 || Editable === 0 ? false : true}
                setValue={handleAssmTitleChange}
                type="SURVEYHEADER1"
                placeholder={
                  assm?.assm_title === "" ? t("common:AssessmentTitle") : assm?.assm_title
                }
              />

              {(!toView || assm?.assm_instructions !== "") && (
                <CustomInput
                  value={
                    assm?.assm_instructions === "" ||
                      assm?.assm_instructions === undefined
                      ? ""
                      : assm?.assm_instructions
                  }
                  editable={toView == 1 || Editable === 0 ? false : true}
                  setValue={handleAssminstructionsChange}
                  type="SURVEYHEADER2"
                  placeholder={
                    assm?.assm_instructions === ""
                      ? "Assessment instructions"
                      : assm?.assm_instructions
                  }
                />
              )}
            </Card.Content>
          </Card>}

          {/* //* Create and Edit  */}
          {toView === 0 && (
            <Card style={styles.cardstyle}>
              <Card.Content>
                <SafeAreaView style={styles.row}>
                  {/* Workflow Select */}
                  <SafeAreaView
                    style={styles.assmsup}>
                    <CustomLabel
                      value={t("common:assmselectworkflow")}
                      type="ASSM"
                    />
                    <CustomDropdown
                      disabled={Editable ? false : true}
                      defValue={selectedWorkflow}
                      options={wfl_options}
                      value={selectedWorkflow}
                      setValue={(e) => handleWorkflowChange(e)}
                      type="ASSESSMENT"
                    />

                    <CustomLabel
                      value={t("common:assmselectcompany")}
                      type="ASSM"
                    />
                    <CustomDropdown
                      disabled={Editable ? false : true}
                      defValue={selectedCompany}
                      options={company_options}
                      value={selectedCompany}
                      setValue={handleCopmanyChange}
                      type="ASSESSMENT"
                    />
                    <CustomLabel value={t("common:assmselectgroup")} type="ASSM" />

                    <CustomDropdown
                      disabled={Editable ? false : true}
                      defValue={selectedGroup}
                      options={groups}
                      value={selectedGroup}
                      setValue={handleGroupChange}
                      type="ASSESSMENT"
                    />
                    <SafeAreaView style={styles.modalCheckBoxRow}>
                      <CustomLabel value={t("common:assmallowflag")} type="CHECKBOXLABEL" />
                      <Checkbox
                        status={
                          assm?.assm_allowChangeOfAppraiser ? "checked" : "unchecked"
                        }
                        onPress={Editable ? handleAssmFlagChange : () => { }}
                      />
                    </SafeAreaView>
                    <PopUpAssm
                      toassmUi={assm?.id}
                      isSectionEmpty={isSectionEmpty}
                      sectionEmpty={sectionEmpty}
                      handleSaveAssm={handleSaveAssm}
                      handleSaveAssmInfo={handleSaveAssmInfo}
                      setFromCopy={setFromCopy}
                      fromCopy={fromCopy}
                      setAssmUi={setAssmUi}
                      importPressed={importPressed}
                      setImportPressed={setImportPressed}
                      setShowResponseScreen={setShowResponseScreen}
                      setShowCreateGroup={setShowCreateGroup}
                      setShowEditGroup={setShowEditGroup}
                      setShowMyAssessments={setShowMyAssessments}
                      setShowAssessmentsAdmin={setShowAssessmentsAdmin}
                      setShowCreateScreen={setShowCreateScreen}
                      setShowEditScreen={setShowEditScreen}
                      setShowParticipationsScreen={setShowParticipationsScreen}
                      isEdit={isEdit}
                    />
                    {sectionQuant && <CustomLabel value={t("common:totalSection") + sectionWeightTotal + '%'} type="ASSM" />}
                  </SafeAreaView>
                  {/* Calendar */}
                  <SafeAreaView style={styles.assmsup}>
                    <CustomLabel
                      value={t("common:selectDateTitle")}
                      type="ASSM"
                    />
                    <View>
                      <CustomInput
                        type='FULL'
                        placeholder={t('common:selectDate')}
                        value={rangeText}
                        editable={false}
                      />
                      {datesError !== "" &&
                        <CustomLabel
                          type='error'
                          value={datesError}
                        />
                      }
                      {/* calendar view */}
                      <View style={{
                        height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 40 / 100 : height * 30 / 100),
                        width: Platform.OS === 'web' ? 485 : width * 90 / 100,
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '4%',
                        borderRadius: 10,
                        borderWidth: 0,
                        borderColor: colors.border_card,
                        backgroundColor: colors.background_card,
                        marginBottom: '-1%',
                      }}>
                        <HelperCalendar
                          style={{
                            height: Platform.OS === 'web' ? 285 : (height < 670 ? height * 40 / 100 : height * 30 / 100),
                            width: Platform.OS === 'web' ? 485 : width * 90 / 100,
                            borderRadius: 10,
                          }}
                          theme={{
                            calendarBackground: colors.background_card,
                            dayTextColor: colors.calendar_numbers,
                            textDisabledColor: '#a1a1a1',
                            monthTextColor: colors.text_secondary,
                            textMonthFontWeight: 'bold',
                            textSectionTitleColor: colors.calendar_numbers,
                            arrowWidth: 30,
                            arrowHeight: 30,
                            arrowColor: colors.calendarArrow,
                            todayTextColor: colors.calendarDotColor,
                            //* Override the calendar day spacing
                            'stylesheet.calendar.main': {
                              week: {
                                justifyContent: 'space-between',
                                flexDirection: 'row',
                              },
                              monthView: {
                                padding: 0,
                                margin: 0,
                              },
                            }
                          }}
                        />
                      </View>
                      {calendarError !== "" &&
                        <CustomLabel
                          type='error'
                          value={calendarError}
                        />
                      }
                      <CustomButton
                        text={t('common:selectDate')}
                        onPress={Editable ? () => { onDatePickerModalConfirm(); } : () => { }}
                        type='SAVE_CALENDAR_DATES_WEB'
                      />
                    </View>
                  </SafeAreaView>
                </SafeAreaView>
              </Card.Content>
            </Card>
          )}

          {/* Assessments core */}
          {((selectedCompany !== "" && selectedWorkflow !== "" && selectedGroup !== "") || 1) &&
            sectionQuestionList?.map((singleSection, index) => (
              <Card style={styles.cardstyle} key={index}>
                <Card.Content>
                  <CustomSection
                    /* Section Related information */
                    sectionTitleChange={(e) => handleSectionChange(e, index)}
                    sectionIndex={index}
                    textFieldSectionName="section_name"
                    sectionName={singleSection.section_name}
                    sectionInstructionsChange={(e) => handleSectionInstructionsChange(e, index)}
                    sectionImgUrlChange={(e) => handleSectionUrlImgChange(e, index)}
                    handleIsSectionCoverChange={(e) => handleIsSectionCoverChange(e, index)}
                    handleUseOnGraphChange={(e) => handleUseOnGraphChange(e, index)}
                    handleGraphAxisChange={(e) => handleGraphAxisChange(e, index)}
                    section_url_img={singleSection.section_url_img}
                    isSectionCover={singleSection.isSectionCover}
                    graphAxis={singleSection.graphAxis}
                    useOnGraph={singleSection.useOnGraph}
                    textFieldSectionInstructions="section_instructions"
                    sectionInstructions={singleSection.section_instructions}
                    sectionId={singleSection.id}
                    sectionQuestionList={sectionQuestionList[index].section_questions}
                    sectionQuestionListStage1={sectionQuestionListStage1 === undefined ? undefined : sectionQuestionListStage1[index]?.section_questions}
                    sectionQuestionListStage2={sectionQuestionListStage2 === undefined ? undefined : sectionQuestionListStage2[index]?.section_questions}
                    sectionQuestionListStage3={sectionQuestionListStage3 === undefined ? undefined : sectionQuestionListStage3[index]?.section_questions}
                    sectionQuantitative={sectionQuestionList[index].section_quantitative}
                    sectionHideComparison={sectionQuestionList[index].section_hideComparison}
                    sectionShowResults={sectionQuestionList[index].section_showResults}
                    handleSectionWeightChange={(e) => handleSectionWeightChange(e, index)}
                    handleSectionQuantitativeChange={(e) => handleSectionQuantitativeChange(e, index)}
                    handleSectionShowResultsChange={(e) => handleSectionShowResultsChange(e, index)}
                    handleSectionHideComparisonChange={(e) => handleSectionHideComparisonChange(e, index)}
                    handleSectionStepsChange={(e) => handleSectionStepsChange(e, index)}
                    /* Add/change/import/remove Question*/
                    handleQuestionAdd={handleQuestionAdd}
                    handleQuestInstructionsChange={handleQuestInstructionsChange}
                    handleQuestionAddFromAssessment={handleQuestionAddFromAssessment}
                    handleQuestionRemove={handleQuestionRemove}
                    handleQuestionChange={handleQuestionChange}
                    /* change question type (default text annswers) */
                    handleQuestionTypeChange={handleQuestionTypeChange}
                    question_types={questionType_options}
                    /* Question rating option add/change/remove subsection */
                    handleQuestionRatingOptionAdd={handleQuestionRatingOptionAdd}
                    handleQuestionRatingOptionChange={handleQuestionRatingOptionChange}
                    handleQuestionRatingOptionRemove={handleQuestionRatingOptionRemove}
                    /* Add/change/remove question lines */
                    handleQuestionLineChange={handleQuestionLineChange}
                    handleQuestionLineAdd={handleQuestionLineAdd}
                    handleQuestionLineRemove={handleQuestionLineRemove}
                    handleQuestionLineResp={handleQuestionLineResp}
                    handleTccQuestionLineAdd={handleTccQuestionLineAdd}
                    handleDeleteTccAnswerGroup={handleDeleteTccAnswerGroup}
                    /* Question options add/change/remove option value in subsection */
                    handleQuestionOptionChange={handleQuestionOptionChange}
                    /* Extra info that need to be passed */
                    Editable={Editable}
                    workflows={workflows}
                    wfl={selectedWorkflow}
                    weight={sectionQuestionList[index].section_weight}
                    selectedSteps={selectedSteps}
                    setSelectedSteps={setSelectedSteps}
                    toView={toView}
                    response_yn={response_yn}
                    currentStage={currentStage}
                    Stages={Stages}
                    assm_submitted={assm?.assm_submitted}
                    isPreview={isPreview}
                    weightMessage={weightMessage}
                    questionWeightTotal={questionWeightTotal}
                    isResult={isResult}
                    stage1Section
                  />


                  {(toView === 0 && Editable === 1) && (
                    <SafeAreaView className="customButtonRight">
                      {sectionQuestionList.length !== 1 && (
                        <CustomButton
                          onPress={() => handleSectionRemove(index)}
                          iconName="trash-outline"
                          show="HOME_BELL"
                          type="HOME_BELL"
                          textTop="0"
                          sz={30}
                        />
                      )}
                    </SafeAreaView>
                  )}
                </Card.Content>
                {(toView === 0 && Editable === 1) && (
                  <Card.Actions>
                    <SafeAreaView style={styles.questionButtonsx}>
                      {sectionQuestionList.length - 1 === index}
                      {/* //* Limit the number of sections, when maximum section number is reached the button disappears   */}
                      {toView === 0 &&
                        sectionQuestionList.length - 1 === index &&
                        sectionQuestionList.length < 4 && (
                          <SafeAreaView style={styles.main}>
                            <View style={styles.rowBtn}>
                              <CustomButton
                                text={t('common:addSection')}
                                onPress={() => handleSectionAdd(index)}
                                iconName='add-outline'
                                show='SURVEY'
                                type='SURVEY'
                                isGradient={true}
                                textTop='0'
                                sz={25}
                              />
                            </View>
                          </SafeAreaView>
                        )}
                    </SafeAreaView>
                  </Card.Actions>
                )}
              </Card>
            ))}

          {/* // * show Participants*/}
          {toView === 0 ? (
            <Card style={styles.cardstyle}>
              <CustomButton
                text={t('common:addPart')}
                onPress={() => {
                  Swal.fire({
                    text: t('common:partmessage'),
                    icon: "info",
                    showCancelButton: true,
                    reverseButtons: true,
                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                    cancelButtonColor: '#d3d3d3',
                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Okay</text>`,
                    confirmButtonColor: '#A0A2FF',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleFinalPartAssm(true) // when next is pressed
                    } else {
                      handleFinalPartAssm(false) // when cancel is pressed
                    }
                  });
                }}
                iconName="person-add-outline"
                show="HOME_BELL"
                type="HOME_BELL"
                textTop="0"
                sz={35}
              />
            </Card>) : <></>
          }

          {/* Assessment Save and Cancel Buttons */}
          {((response_yn && currentStage === Stages) || !toView) &&
            <Card.Actions>
              <SafeAreaView style={styles.modalButtonsRow}>
                <CustomButton
                  text={Platform.OS === "web" && width > 1300 ? t("common:cancel") : ""}
                  onPress={response_yn ? () => handleShowAssessments() :
                    () => {
                      Swal.fire({
                        title: t("common:areusure"),
                        text: isEdit ? t("common:cancelEditMsg") : t("common:cancelCreationMsg"),
                        icon: "warning",
                        showCancelButton: true,
                        reverseButtons: true,
                        cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                        cancelButtonColor: '#d3d3d3',
                        confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Okay</text>`,
                        confirmButtonColor: '#A0A2FF',
                      }).then((result) => {
                        if (result.isConfirmed) {
                          handleFinalCancelAssm(true) // when okay is pressed
                        } else {
                          handleFinalCancelAssm(false) // when cancel is pressed
                        }
                      });
                    }
                  }
                  iconName="close-circle-outline"
                  show="SURVEYREJECT"
                  type="SURVEYREJECT"
                  textTop="0"
                  sz={20}
                />
                <CustomButton
                  text={Platform.OS === "web" && width > 1300 ? isEdit ? t("common:updateassm") : t("common:save") : ""}
                  onPress={response_yn ? () => {
                    setFinalizeResponse(true); // Perform the state update first
                    handleUpdateResponse(true);
                  } : () => handleSaveAssm()} // Call the other function
                  iconName="save-outline"
                  show="SURVEY"
                  type="SURVEY"
                  textTop="0"
                  isGradient={true}
                  sz={20}
                />
                {response_yn && (
                  <CustomButton
                    text={Platform.OS === "web" && width > 1300 ? t("common:submit") : ""}
                    onPress={() => {
                      setFinalizeResponse(true); // Perform the state update first
                      handleUpdateResponse(false); // Then call the function
                    }}
                    iconName="checkmark-circle-outline"
                    show="SURVEY"
                    type="SURVEY"
                    textTop="0"
                    sz={20}
                  />
                )}
              </SafeAreaView>
            </Card.Actions>
          }
        </ScrollView>
      </SafeAreaView>
    </SafeAreaView >
  );
};

const makeStyles = (colors, width, height) =>
  StyleSheet.create({
    main: {
      flex: 1,
      alignItems: "center",
      margin: 20,
    },
    rowContainer: {
      flex: 1,
      flexDirection: 'row',
    },
    rowSubContainer: {
      flex: 1,
      flexDirection: 'row',
    },
    rowMainContainer: {
      flex: 4,
      flexDirection: 'row',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
      marginBottom: 8,
    },
    supportContainer: {
      flex: 1,
      margin: 10,
      padding: 10,
      borderRadius: 35,
      backgroundColor: colors.background_card,
      elevation: 10,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
    },
    mainContainer: {
      flex: 1,
      padding: 15,
    },
    modalButtonsRow: {
      flexDirection: "row",
      justifyContent: "flex-end",
      padding: 10,
    },
    modalCheckBoxRow: {
      width: '100%',
      flexDirection: "row",
    },
    assmsup: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      padding: 10,
      margin: 10,
    },
    cardstyle: {
      padding: 10,
      marginHorizontal: 5,
      marginVertical: 20,
      width: "98%",
      borderRadius: 35,
      backgroundColor: colors.background_card,
      elevation: 5,
      shadowColor: colors.card_line,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 10,
    },
    actions: {
      width:
        Platform.OS === "web" && width > 1300
          ? width - (width * 35) / 100
          : (width * 80) / 100,
      justifyContent: "center",
      alignItems: "flex-end",
    },
    row: {
      flexDirection: 'row',
      flex: 1,
    },
    column: {
      flex: 1,
    },
    line: {
      borderBottomColor: colors.buttons_primary,
      borderBottomWidth: StyleSheet.hairlineWidth,
      marginTop: "1%",
      marginBottom: "1%",
    },
    rowBtn: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },

  });

export default CustomAssessment;
